module.exports = __webpack_public_path__ + "img/Dohler.445cec56.png";